// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3725) return "static/chunks/3725-73e37db986eae547.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1160":"a77c0a214e6cf3bb","3509":"e01e052f34366202","5977":"4511b45d871ae0f3","8800":"94b07274cba99a66","9343":"44a5e68ac002a9f7","9477":"3292b4d86ecd27a5"}[chunkId] + ".js";
};